import React, { Component, useEffect, useState, useRef } from "react";
import axios from "axios";
import emptydata from "../media/undraw_connected_world_wuay.svg";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';


function DataHub() {

  const [catselection, setcatselection] = useState([]);
  console.log(catselection);
  const [totalpage, settotalpage] = useState();
  const [nextpage, setnextpage] = useState();
  const [previouspage, setpreviouspage] = useState();
  const [currentpage, setcurrentpage] = useState();
  const Auth = localStorage.getItem("Auth");

  console.log()

  const [dataRequest, setdataRequest] = useState({
    "company_name": "",
    "city": "",
    "state": "",
    "address": "",
    "mobile_verified": "",
    "email_verified": "",
    "sellinterest": "",
    "description": ""
  });


  const businessCat =[
    'Admission Services','Advertising','Aeronautics Aerospace & Defence','Agriculture','AI','Airport Operations','Analytics','Animation','Apparel & Garments','AR VR (Augmented + Virtual Reality)','Architecture Interior Design','Art & Photography','Astrology','Automobile','Automotive','Ayurvedic Product','Bags','Belts','Bicycle & Rickshaw','Biotechnology','Books','Bpo Services','Building & Construction','Business Audit','Call Center','Career Guidance','Career Guidance Center','Chemicals','Chemicals Dyes','Coaching Classes','Communication Skills Training','Computer','Computer Vision','Construction','Copyright & Trademark','Corporate Law Services','Cosmetics','Dance Schools','Data Entry','Data Processing Service','Dating Matrimonial','Decoratives','Design','Domestic Relocation Service','Drugs & Pharmaceuticals','Education','Education & Training','Electronics & Electrical','Enterprise Software','Event Planner','Events','Fabrics','Farming','Fashion','Finance Consultant','Finance Technology','Financial & Legal Services','Fitness Supplements','Food & Beverages','Furnishing','Furniture','Gems','Green Technology','Handicrafts','Healthcare & Lifesciences','Herbal','Home Textile','Hospital & Diagnostics','Hotels','House-Hold Services','Housekeeping Services','Housewares','Hr Outsourcing','HR Planning','Human Resources','Income Tax Consultant','Indic Language Startups','Industrial Plants & Machinery','Industrial Supplies','Insurance Agent','Insurance Service','Internet of Things','IT Services','Jewelry','Job Consultation Service','Kitchen Utensils','Lab Instruments','Labor Contractors','Leather Products','Logistics','Machine Tools','Manpower Service','Marketing','Mechanical parts & spares','Media & Entertainment','Media & Publishing','Medical Treatment Services','Metals & Minerals','Motor Driving School','Music Schools','Nanotechnology','Network Devices','Non- Renewable Energy','Other Specialty Retailers','Packaging Machines','Passenger Experience','Payroll Services','Pcd Pharma Franchise','Personal Care','Pets & Animals','Placement Consultants','Plumbing Contractors','Professional & Commercial Services','Real Estate','Recruitment','Renewable Energy','Retail','Robotics','Safety','Security Solutions','Security Systems','Skill Development Services','Social Impact','Social Network','Solvents','Sports','Stationery','Stockbrokers','Tax Planners','Technology Hardware','Telecom Equipment','Telecom Services','Telecommunication & Networking','Testing Labs','Textiles','Textiles & Apparel','Toys','Toys and Games','Transportation','Transportation & Storage','Travel & Tourism','Truck Rentals','Tuition Centers','Vocational Education','Wallets','Waste Management'
   ];



  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;

    if (checked) {
      setcatselection([...catselection, value]);
    } else {
      setcatselection(catselection.filter((item) => item !== value));
    }
  };

  const selectCategory = (event) =>{
    const { value, checked } = event.target;
    setcatselection([...catselection, value]);
  }

  const stateCat = [ "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry"]

  const [Leads, setLeads] = useState();

  
  function updataDatahubFilter(e) {
    setdataRequest({ ...dataRequest, [e.target.name]: e.target.value });
  }


  function getdatafromhub(url) {
    const headers = {
      "Content-Type": "text/plain",
    };
    console.log(url);

    axios
      .post(
        url, {
          "company_name": "",
          "catagory_likewise": catselection,
          "city": "",
          "state": "",
          "address": "",
          "mobile_verified": "",
          "email_verified": "",
          "sellinterest": "",
          "description": ""
        } ,
        headers
      )
      .then((data) => {
        if (data.status == "200") {
          setLeads(data.data.records);
          settotalpage(data.data.total_number_of_pages)
          setnextpage(data.data.pagination.next);
          setpreviouspage(data.data.pagination.previous);
          setcurrentpage(data.data.page_number);
        }
      })
      .catch((err) => {
      
      });
  }


  function getContact(id, map, leadtype) {


    const headers = {
      "Content-Type": "text/plain",
      Authorization: `Bearer ${Auth}`,
    };
    axios
      .get("/Get_datalake_contact_details?id=".concat(id), {
        headers,
      })
      .then((data) => {
        if (data.status == "200") {

          let ChangeValue = Leads;

       
            ChangeValue[map].email1 = data.data[0].email1;
            ChangeValue[map].pns_no = data.data[0].pns_no;

        
          
          
       
          setLeads(ChangeValue);
          console.log(ChangeValue,'ChangeValue');
          document.getElementById("pills-home-tab").click();
         
        }
        
      })
      .catch((err) => console.log(err));
  }


  
  function changeinterest(item){

  
   var showcat = item;
   var showcat = showcat.join(', ')
    return showcat;

  }

  function changesector(item){

    item  = item.replaceAll('[', '');
    item  = item.replaceAll(']', '');
    item  = item.replaceAll("'", '');
    return item;
  } 


  function clearfilter(){

    setdataRequest({
      "company_name": "",
      "city": "",
      "state": "",
      "address": "",
      "mobile_verified": "",
      "email_verified": "",
      "sellinterest": "",
      "description": ""
    });

    setcatselection([]);

  }

  function cleararray(){

    const arraylen = catselection.length;
    
    if(arraylen > '1' ){


      setcatselection([catselection.pop()]);
       }


  }

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props}
    </Tooltip>
  );

  const renderPopover = (props1,props2) => (
    <Popover id="popover-basic">
    <Popover.Header as="h3">{props1}</Popover.Header>
    <Popover.Body>
    {props2}
    </Popover.Body>
    </Popover>
  );

  function returndesc(item){

    item = item.replace(/<[^>]*>?/gm, '');
    item = item.replace(/\r?\n|\r/, '');
    item = item.replace('&nbsp;', ' ');
    item = item.replace('&amp;', ' ');
    item = item.replaceAll('\r;', ' ');
    item = item.replaceAll('\n;', ' ');

    return <OverlayTrigger trigger="click" placement="bottom" overlay={renderPopover("Company Description", item)}>
    <i className="bi bi-info-circle-fill"></i>
            </OverlayTrigger>

  } 


  return (
    <>
     
      
      <div className="container">
        <h4><i className="bi bi-globe"></i> Sunday's Data Hub <span className="badge bg-danger">Beta</span></h4>
        <p>Find potential customers for your product/service from the internet!</p>
        <br/>
        <>
  <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
    <li className="nav-item" role="presentation">
      <button
        className="nav-link active"
        id="pills-home-tab"
        data-bs-toggle="pill"
        data-bs-target="#pills-home"
        type="button"
        role="tab"
        aria-controls="pills-home"
        aria-selected="true"
        onClick={clearfilter}
      >
        <i className="bi bi-app"></i> Simple Search
      </button>
    </li>
    <li className="nav-item" role="presentation">
      <button
        className="nav-link"
        id="pills-profile-tab"
        data-bs-toggle="pill"
        data-bs-target="#pills-profile"
        type="button"
        role="tab"
        aria-controls="pills-profile"
        aria-selected="false"
        onClick={clearfilter}
      >
        <i className="bi bi-grid-3x3-gap"></i> Advance Search
      </button>
    </li>
 
  </ul>
  <div className="tab-content" id="pills-tabContent">
    <div
      className="tab-pane fade show active"
      id="pills-home"
      role="tabpanel"
      aria-labelledby="pills-home-tab"
      align='center'
    >
      <br/>
      <p>Search by categories <i className="bi bi-arrow-down"></i></p>
      <div className="col-6">
      <div className="input-group">
  <select
    className="form-select bg-dark border-dark text-light"
    id="inputGroupSelect04"
    aria-label="Example select with button addon"
    name="catselection"
    value={catselection[0]}
    onChange={selectCategory}
    onClick={cleararray}
  >
    <option selected="">Choose...</option>
    {businessCat &&
                        businessCat?.map((item) => (
                          <option value={item}>{item}</option>
                          ))}
  </select>
  <button className="btn btn-light border-dark" type="button" onClick={()=>getdatafromhub("/find_data_from_datalake?page_num=1&page_size=4")}>
  <i className="bi bi-search"></i> Search
  </button>
</div>
      </div>
    </div>
    <div
      className="tab-pane fade"
      id="pills-profile"
      role="tabpanel"
      aria-labelledby="pills-profile-tab"
    >
     <br/>
     <div className="row">
        <div className="col-9">
        <div className="accordion" id="accordionPanelsStayOpenExample">
  <div className="accordion-item">
    <h2 className="accordion-header" id="panelsStayOpen-headingTwo">
      <button
        className="accordion-button collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#panelsStayOpen-collapseTwo"
        aria-expanded="false"
        aria-controls="panelsStayOpen-collapseTwo"
      >
        Advance search
      </button>
    </h2>
    <div
      id="panelsStayOpen-collapseTwo"
      className="accordion-collapse collapse"
      aria-labelledby="panelsStayOpen-headingTwo"
      
    >
      <div className="accordion-body">
     <div className="row">
      <div className="col-6">
      <div class="mb-3">
  <label for="exampleFormControlInput1" class="form-label">Business Category: </label>
  <div
                className="overflow-auto p-3"
                style={{ maxWidth: "500px", maxHeight: "400px" }}
              >
                   {businessCat &&
                        businessCat?.map((item) => (
                          <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue=""
                            id="flexCheckChecked"
                            value={item}
                            checked={catselection.includes(item)}
                            onChange={handleCheckboxChange}
                          />
                          <label className="form-check-label" htmlFor="flexCheckChecked">
                            {item}
                          </label>
                        </div>
                          ))}

 
  
                </div>
</div>

     
      </div>

<div className="col-6">
<p><strong>Details Verified:</strong></p>
<div className="form-check">
  <input
    className="form-check-input"
    type="checkbox"
    defaultValue=""
    id="flexCheckDefault"
    name="mobile_verified"
    value="Verified"
    checked={dataRequest.mobile_verified}
    onChange={updataDatahubFilter}
    
  />
  <label className="form-check-label" htmlFor="flexCheckDefault">
    Phone Number
  </label>
</div>


<div className="form-check">
  <input
    className="form-check-input"
    type="checkbox"
    defaultValue=""
    id="flexCheckDefault"
    name="email_verified"
    value="Verified"
    checked={dataRequest.email_verified}
    onChange={updataDatahubFilter}
  />
  <label className="form-check-label" htmlFor="flexCheckDefault">
    Email Id
  </label>
</div>
<br/>
<label for="exampleFormControlInput2" class="form-label">Select State:</label>
<select className="form-select" aria-label="Default select example" id="exampleFormControlInput2">
  <option selected="">Open this select menu</option>
  {stateCat &&
                        stateCat?.map((item) => (
                          <option value={item}>{item}</option>
  ))}

</select>
<br/>
{/* <label for="exampleFormControlInput2" class="form-label">Select City:</label>
<select className="form-select" size={3} aria-label="size 3 select example" id="exampleFormControlInput2">
  <option selected="">Open this select menu</option>
  <option value={1}>One</option>
  <option value={2}>Two</option>
  <option value={3}>Three</option>
</select> */}

</div>

     </div>

      </div>
    </div>
  </div>
</div>
        </div>
        <div className="col-3">
        <button type="button" className="btn btn-dark" onClick={()=>getdatafromhub("/find_data_from_datalake?page_num=1&page_size=4")} >
        <i className="bi bi-search"></i>  Search
</button>
        </div>
       </div>

    </div>
    
  </div>
</>


        
<br/>
    
     
      {Leads == null?(
         <div align="center">
         <br/><br/>
         <img src={emptydata} height={300} />
         </div>
      ):(<><br/><br/><div
        className="overflow-auto"
        style={{ maxWidth: "1800px", maxHeight: "800px" }}
      >
        <table className="table">
<thead>
<tr>
<th scope="col"><i className="bi bi-building"></i> Company</th>
<th scope="col"><i className="bi bi-person-badge-fill"></i> Name</th>
<th scope="col"><i className="bi bi-person-lines-fill"></i> Contact</th>
<th scope="col"><i class="bi bi-tag-fill"></i> Category</th>
<th scope="col"><i className="bi bi-compass-fill"></i> Location</th>
</tr>
</thead>
<tbody>
{Leads &&
                        Leads?.map((item,index) => (
                        //   item.industries!=null?<tr>
                        //     <td scope="row">{item.company_name} {item.website !=''?<a href={item.website} target="_blank"><i className="bi bi-link-45deg"></i></a>:null}{returndesc(item.brief)}<br/><div className="text-secondary">{item.country}</div></td>

                        //   <td colspan="2" >
                        //     {item.email=='abcxxxx@xxxx.xx'?<><i className="bi bi-envelope-fill"></i> {" "}<strong className='blur'>email@salessunday.com</strong> <i className="bi bi-eye-fill" onClick={()=>getContact(item._id,index,'email')}></i></>
                        //   :<><i className="bi bi-envelope-fill"></i> {" "}{item.email}{" "}</>} 
                        //  </td>

                        //   <td>Industry : <b>{changesector(item.industries)}</b>, Sector : <b>{changesector(item.sectors)}</b> </td>

                        //   <td>{item.city}<br/> <div className="text-secondary">{item.state}</div></td>
                          
                         
                        // </tr>
                        <tr>
                        <td scope="row">
                          {item.company_name !== 'nan' && item.company_name}
                          {item.website && item.website !== 'nan' && item.website !== '' && (
                            <a href={item.website} target="_blank" rel="noopener noreferrer">
                              <i className="bi bi-link-45deg"></i>
                            </a>
                          )}
                          {item.company_description && item.company_description !== 'nan' && (
                            <> {returndesc(item.company_description)}</>
                          )}
                          <br />
                          <div className="text-secondary">{item.country}</div>
                        </td>
                      
                        <td>
                          <strong>
                            <i className="bi bi-person-circle"></i>{" "}
                            {item.first_name !== 'nan' ? item.first_name : ''}{" "}
                            {item.last_name !== 'nan' ? item.last_name : ''}
                          </strong>
                          <br />
                          {item.designation && (
                            <span className="badge bg-info text-dark">{item.designation}</span>
                          )}
                        </td>
                      
                        <td>{item.email1=='abcxxxx@xxxx.xx'?<><i className="bi bi-envelope-fill"></i> {" "}<strong className='blur'>email@salessunday.com</strong> <i className="bi bi-eye-fill" onClick={()=>getContact(item._id,index,'email')}></i></>
                          :<><i className="bi bi-envelope-fill"></i> {" "}{item.email1}{" "}</>} 
                          {" "}{item.mobile_verified == 'Verified'?<i className="bi bi-patch-check-fill text-primary"></i>:null}<br/>
                          <strong>
                          {item.pns_no=='+91 xxxx xxx xxx'?<><i className="bi bi-phone-fill"></i>{" "} +{item.mobile_country_code} <strong className='blur'>8888888888</strong> <i className="bi bi-eye-fill" onClick={()=>getContact(item._id,index,'contact')}></i></>
                          :<><i className="bi bi-phone-fill"></i>{" "} +{item.glusr_usr_mobile_country} {" "}{item.pns_no}{" "}</>}
                          {" "}{item.mobile_verified == 'Verified'?<i className="bi bi-patch-check-fill text-primary"></i>:null}</strong></td>
                      
                        <td>
                          {item.category_likewise && item.category_likewise !== 'nan'
                            ? changeinterest(JSON.parse(item.category_likewise.replace(/'/g, '"')))
                            : null}
                        </td>
                      
                        <td>
                          {item.city !== 'nan' ? item.city : ''} - {item.zip !== 'nan' ? item.zip : ''}
                          <br />
                          <div className="text-secondary">{item.state !== 'nan' ? item.state : ''}</div>
                        </td>
                      </tr>
                          
                        
                        ))}

</tbody>
</table>


      </div><>
      <nav
                className="d-grid gap-2 d-md-flex justify-content-md-end"
                aria-label="..."
              >
                <ul className="pagination">
                  <li className="page-item">
                    <a className="btn btn-light">
                      
                      Total Pages: <b>{totalpage}</b>
                    </a>
                  </li>
       
<li className="page-item ">
                    <a
                      className="page-link bg-dark text-white pop rounded"
                      style={{ cursor: "pointer" }}
                      onClick={()=>getdatafromhub(previouspage)}
                      
                    >
                      <i className="bi bi-arrow-left-circle" /> Previous
                    </a>
                  </li>

                  
                  <li className="page-item ">
                    <a className="page-link text-dark border-0 bg-transparent">
                      <b>{currentpage}</b>
                    </a>
                  </li>

<li className="page-item ">
                    <a
                      className="page-link bg-dark text-white pop rounded"
                      style={{ cursor: "pointer" }}
                      onClick={()=>getdatafromhub(nextpage)}
                    >
                      Next <i className="bi bi-arrow-right-circle" />
                    </a>
                  </li>



                  
                </ul>
              </nav></></>)
      
      }
      
      </div>
      <div className="container" align='center'>
      <p>
         <svg
  xmlns="http://www.w3.org/2000/svg"
  width={16}
  height={16}
  fill="currentColor"
  className="bi bi-globe-americas"
  viewBox="0 0 16 16"
>
  <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0ZM2.04 4.326c.325 1.329 2.532 2.54 3.717 3.19.48.263.793.434.743.484-.08.08-.162.158-.242.234-.416.396-.787.749-.758 1.266.035.634.618.824 1.214 1.017.577.188 1.168.38 1.286.983.082.417-.075.988-.22 1.52-.215.782-.406 1.48.22 1.48 1.5-.5 3.798-3.186 4-5 .138-1.243-2-2-3.5-2.5-.478-.16-.755.081-.99.284-.172.15-.322.279-.51.216-.445-.148-2.5-2-1.5-2.5.78-.39.952-.171 1.227.182.078.099.163.208.273.318.609.304.662-.132.723-.633.039-.322.081-.671.277-.867.434-.434 1.265-.791 2.028-1.12.712-.306 1.365-.587 1.579-.88A7 7 0 1 1 2.04 4.327Z" />
</svg> All our data comes from interet search algorithm.
        </p>
      </div>
      
      
    </>
  );
}

export default DataHub;
